import { fetchProducts } from '../../Listing/actions/listingActions';
import * as paginationActions from './actionTypes';

export const updatePagination = (currentPage, pageCount) => ({
    type: paginationActions.STORE_PAGINATION,
    payload: { currentPage, pageCount }
});

export const changePage = page => (dispatch) => {
    dispatch(fetchProducts(page));
};
